import React from 'react';

import propTypes from './propTypes';

import { Container, Label, SelectContainer } from './styles';

const ColumnContainer = ({ children, title }) => (
    <Container>
        <Label>{title}</Label>
        <SelectContainer>{children}</SelectContainer>
    </Container>
);

ColumnContainer.propTypes = propTypes;

export default ColumnContainer;
